module.exports = __webpack_public_path__ + "media/images/image-1-77a833ae.jpg";